import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { V2_ROUTE_PAGES } from '@aware/v2-routes/constants';
import V2SettingsIframe from '@aware/common/v2-settings-iframe';
import { replaceCancelButtonAction } from './helpers';

const CreateNewStudentInventoryType = () => {
  const history = useHistory();
  const location = useLocation();

  const redirectFn = () => {
    history.push('create-new-student-inventory-type');
  };

  useEffect(() => {
    window.top.newStudentInventoryCallbackFn = newInventoryId => {
      history.push(
        `${V2_ROUTE_PAGES.assessmentsSettings}/configure-student-inventory-types/${newInventoryId}`
      );
    };

    return () => delete window.top.newStudentInventoryCallbackFn;
  }, [history]);

  return (
    <V2SettingsIframe
      iframeSrc="/aware/?embed=1&detailsSrc=/aware/Manage/StudentInventory/NewInventoryWizard.aspx?embed=1"
      title="Create New Student Inventory Type"
      key={location.key}
      onLoadCallback={iframe => replaceCancelButtonAction({ iframe, redirectFn })}
    />
  );
};

export default CreateNewStudentInventoryType;
